<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="platform === platformRef.desktop"
        id="close-modal-btn"
        data-cy="close-copy-products-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label [attr.data-cy]="'copy-to-groups-title'" class="title-bold">
      {{ title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <div>
    <ion-item class="list-title">
      {{ 'i18n.lists.copyProductsModal.copyProductsGroupTarget' | translate }}
    </ion-item>
    <ion-list>
      <ion-item *ngFor="let group of selectedGroups">
        <ion-checkbox
          class="checkbox"
          mode="ios"
          alignment="center"
          label-placement="start"
          [checked]="group?.isSelected"
          (ionChange)="
            onSelectGroup(group?.groupState?.groupName, group.isSelected)
          "
          >{{ group?.groupState?.groupName }}</ion-checkbox
        >
      </ion-item>
    </ion-list>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [attr.data-cy]="'copy-list-cancel-button'"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        [attr.data-cy]="'copy-list-next-button'"
        [ngClass]="
          numGroupsSelected === 0
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
